<template>
  <div class="menu-wrapper">
    <template v-for="item in routes">
      <el-submenu
        v-if="!item.hidden && hasVisibleChildren(item)"
        :index="resolvePath(item)"
        :key="item.name || item.path"
      >
        <template slot="title">
          <svg-icon
            v-if="item.meta && item.meta.icon"
            :icon-class="item.meta.icon"
          ></svg-icon>
          <span v-if="item.meta && item.meta.title" slot="title">{{
            item.meta.title
          }}</span>
        </template>

        <template v-for="child in item.children">
          <sidebar-item
            v-if="!child.hidden && hasVisibleChildren(child)"
            :is-nest="true"
            class="nest-menu"
            :routes="[child]"
            :key="child.name || child.path"
          ></sidebar-item>
          <a
            v-else-if="!child.hidden && isExternal(child)"
            :href="resolvePath(child, resolvePath(item))"
            target="_blank"
            :key="child.name || child.path"
          >
            <el-menu-item :index="resolvePath(child, resolvePath(item))">
              <svg-icon
                v-if="child.meta && child.meta.icon"
                :icon-class="child.meta.icon"
              ></svg-icon>
              <span v-if="child.meta && child.meta.title" slot="title">{{
                child.meta.title
              }}</span>
            </el-menu-item>
          </a>
          <router-link
            v-else-if="!child.hidden"
            :to="resolvePath(child, resolvePath(item))"
            :key="child.name || child.path"
          >
            <el-menu-item :index="resolvePath(child, resolvePath(item))">
              <svg-icon
                v-if="child.meta && child.meta.icon"
                :icon-class="child.meta.icon"
              ></svg-icon>
              <span v-if="child.meta && child.meta.title" slot="title">{{
                child.meta.title
              }}</span>
            </el-menu-item>
          </router-link>
        </template>
      </el-submenu>

      <a
        v-else-if="!item.hidden && isExternal(item)"
        :href="resolvePath(item)"
        target="_blank"
        :key="item.name || item.path"
      >
        <el-menu-item :index="resolvePath(item)">
          <svg-icon
            v-if="item.meta && item.meta.icon"
            :icon-class="item.meta.icon"
          ></svg-icon>
          <span v-if="item.meta && item.meta.title" slot="title">{{
            item.meta.title
          }}</span>
        </el-menu-item>
      </a>
      <router-link
        v-else-if="!item.hidden"
        :to="resolvePath(item)"
        :key="item.name || item.path"
      >
        <el-menu-item :index="resolvePath(item)">
          <svg-icon
            v-if="item.meta && item.meta.icon"
            :icon-class="item.meta.icon"
          ></svg-icon>
          <span v-if="item.meta && item.meta.title" slot="title">{{
            item.meta.title
          }}</span>
        </el-menu-item>
      </router-link>
    </template>
  </div>
</template>

<script>
export default {
  name: 'SidebarItem',
  props: {
    routes: {
      type: Array,
      default: () => [],
    },
    isNest: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    hasVisibleChildren(route) {
      return (
        Array.isArray(route.children) &&
        route.children.some(child => !child.hidden)
      );
    },
    isExternal(route) {
      return /^https?:\/\//.test(route.fullPath || route.path || '');
    },
    resolvePath(route, parentPath = '') {
      if (route.fullPath) {
        return route.fullPath;
      }
      const path = route.path || '';
      if (path.charAt(0) === '/') {
        return path;
      }
      if (!parentPath || parentPath === '/') {
        return `/${path}`.replace(/\/$/, '') || '/';
      }
      return `${parentPath.replace(/\/$/, '')}/${path}`.replace(/\/$/, '') || '/';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue